import './BottomBar.css'

function BottomBar() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className='bottom-bar'>
      <span>
        Copyright © {currentYear} Buck Press Limited. All rights reserved
      </span>
      <span>Publishing Department</span>
    </footer>
  )
}

export default BottomBar
